export const NAVColumnsList = [
    {
        key:"dashboard",
        icon:"fa fa-home",
        label: "Dashboard"
    },
    {
        key:"billing",
        icon:"fa fa-money-bill",
        label: "Tagihan"
    },
    {
        key:"fup",
        icon:"fa fa-link",
        label: "Quota",
        feature: "enableFupSupport"
    },
    {
        key:"history",
        icon:"fa fa-history",
        label: "Riwayat"
    },
    {
        key:"profile",
        icon:"fa fa-user",
        label: "Profile Saya"
    },
];
